<template>
  <div class="text-left row">
    <div class="col">
      <h5><b>Users</b></h5>
      <div class="mb-2" style="background-color:gray; height:1px; width:100%" />
      <div
        v-for="(user, index) in users.slice().sort($orderByLastName)"
        :key="index + 'user'"
      >
        <label
          class="btn pointer"
          v-bind:class="{
            'btn-primary': selectedUser.User_Id == user.User_Id,
            'btn-outline-primary': selectedUser.User_Id != user.User_Id
          }"
          v-on:click="manageUser(user)"
        >
          {{ user.First_Name }} {{ user.Last_Name }}
        </label>
      </div>
    </div>
    <div v-if="selectedUser.User_Id" class="col">
      <h5><b>Organizations</b></h5>
      <div class="mb-2" style="background-color:gray; height:1px; width:100%" />
      <div
        v-for="(organization, index) in organizations
          .slice()
          .sort($orderByName)"
        :key="index + 'organization'"
      >
        <h6>
          <b>{{ organization.Name }}</b>
          {{
            organization.Organization_Type_Id == 3
              ? "(School)"
              : organization.Organization_Type_Id == 4 ? "(Company)"
              : "(Group)"
          }}
        </h6>
        <div
          v-for="permission in availablePermissions.filter(
            g => g.Permission_Type.Permission_Type_Id == '2'
          )"
          :key="organization.Organization_Id + 'org' + permission.Permission_Id"
        >
          <label
            class="btn btn-sm"
            v-bind:for="
              organization.Organization_Id + 'org' + permission.Permission_Id
            "
            v-bind:class="{
              'btn-primary': newUserOrganizationPermissions.some(
                i =>
                  i.organization == organization.Organization_Id &&
                  i.permission == permission.Permission_Id
              ),
              'btn-outline-primary': !newUserOrganizationPermissions.some(
                i =>
                  i.organization == organization.Organization_Id &&
                  i.permission == permission.Permission_Id
              )
            }"
          >
            <input
              style="display: none"
              type="checkbox"
              v-bind:name="
                organization.Organization_Id + 'org' + permission.Permission_Id
              "
              v-bind:id="
                organization.Organization_Id + 'org' + permission.Permission_Id
              "
              v-bind:value="{
                organization: organization.Organization_Id,
                permission: permission.Permission_Id
              }"
              v-model="newUserOrganizationPermissions"
              v-on:change="
                addRemovePermission($event, {
                  organization: organization.Organization_Id,
                  permission: permission.Permission_Id
                })
              "
            />{{
              organization.Organization_Type_Id == 3
                ? "School Manager"
                : "Group Manager"
            }}
          </label>
        </div>
      </div>
    </div>
    <div v-if="selectedUser.User_Id" class="col">
      <h5><b>Subjects</b></h5>
      <div class="mb-2" style="background-color:gray; height:1px; width:100%" />
      <div
        v-for="(subject, index) in subjects.slice().sort($orderByTitle)"
        :key="index + 'subject'"
      >
        <h6>
          <b>{{ subject.Title }}</b>
        </h6>
        <p
          class="text-secondary"
          style="line-height: 1;"
          v-if="
            newUserOrganizationPermissions.some(
              o => o.organization == subject.Organization_Id
            )
          "
        >
          <small>
            This user has permissions to this subject based on their permission
            to
            {{
              organizations.find(
                o => o.Organization_Id == subject.Organization_Id
              ).Name
            }}.
          </small>
        </p>
        <div
          v-for="permission in availablePermissions.filter(
            g => g.Permission_Type.Permission_Type_Id == '3'
          )"
          :key="subject.Subject_Id + 'sub' + permission.Permission_Id"
        >
          <label
            class="btn btn-sm"
            v-bind:for="subject.Subject_Id + 'sub' + permission.Permission_Id"
            v-bind:class="{
              'btn-primary': newUserSubjectPermissions.some(
                i =>
                  i.subject == subject.Subject_Id &&
                  i.permission == permission.Permission_Id
              ),
              'btn-outline-primary': !newUserSubjectPermissions.some(
                i =>
                  i.subject == subject.Subject_Id &&
                  i.permission == permission.Permission_Id
              ),
              disabled: newUserOrganizationPermissions.some(
                o => o.organization == subject.Organization_Id
              )
            }"
          >
            <input
              style="display: none"
              type="checkbox"
              v-bind:disabled="
                newUserOrganizationPermissions.some(
                  o => o.organization == subject.Organization_Id
                )
              "
              v-bind:name="
                subject.Subject_Id + 'sub' + permission.Permission_Id
              "
              v-bind:id="subject.Subject_Id + 'sub' + permission.Permission_Id"
              v-bind:value="{
                subject: subject.Subject_Id,
                permission: permission.Permission_Id
              }"
              v-model="newUserSubjectPermissions"
              v-on:change="
                addRemovePermission($event, {
                  subject: subject.Subject_Id,
                  permission: permission.Permission_Id
                })
              "
            />{{ permission.Title }}
          </label>
        </div>
      </div>
    </div>
    <div v-if="selectedUser.User_Id" class="col">
      <h5><b>Students</b></h5>
      <div class="mb-2" style="background-color:gray; height:1px; width:100%" />
      <div
        v-for="(student, index) in students.slice().sort($orderByName)"
        :key="index + 'student'"
      >
        <h6>
          <b>{{ student.Name }}</b>
        </h6>
        <div
          v-for="permission in availablePermissions.filter(
            g => g.Permission_Type.Permission_Type_Id == '4'
          )"
          :key="student.Student_Id + 'student' + permission.Permission_Id"
        >
          <label
            class="btn btn-sm"
            v-bind:for="
              student.Student_Id + 'student' + permission.Permission_Id
            "
            v-bind:class="{
              'btn-primary': newUserStudentPermissions.some(
                i =>
                  i.student == student.Student_Id &&
                  i.permission == permission.Permission_Id
              ),
              'btn-outline-primary': !newUserStudentPermissions.some(
                i =>
                  i.student == student.Student_Id &&
                  i.permission == permission.Permission_Id
              )
            }"
          >
            <input
              style="display: none"
              type="checkbox"
              v-bind:id="
                student.Student_Id + 'student' + permission.Permission_Id
              "
              v-bind:value="{
                student: student.Student_Id,
                permission: permission.Permission_Id
              }"
              v-model="newUserStudentPermissions"
              v-on:change="
                addRemovePermission($event, {
                  student: student.Student_Id,
                  permission: permission.Permission_Id
                })
              "
            />{{ permission.Title }}
          </label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//import $ from "jquery";

export default {
  name: "UserPermissions",
  props: {
    UserId: String,
    Organization: Object
  },
  data() {
    return {
      organizations: [],
      subjects: [],
      users: [],
      students: [],
      organizationStudents: [],
      selectedUser: {},
      originalUserStudentPermissions: [],
      originalUserSubjectPermissions: [],
      originalUserOrganizationPermissions: [],
      newUserSubjectPermissions: [],
      newUserStudentPermissions: [],
      newUserOrganizationPermissions: [],
      availablePermissions: []
    };
  },
  created() {
    this.$store.commit("updateLoading", true);
  },
  async mounted() {
    this.availablePermissions = await this.$getAllPermissions();
    await this.loadData();
    this.$store.commit("updateLoading", false);
  },
  methods: {
    async loadData() {
      if (
        this.$canManageAccount(
          this.$store.getters.user.Permissions,
          this.Organization.Account.Account_Id
        ) ||
        this.$canManageOrganization(
          this.$store.getters.user.Permissions,
          this.Organization.Organization_Id
        )
      ) {
        this.students = await this.$getPermissionStudents();
        this.organizations = (await this.$getPermissionOrganizations()).filter(
          o =>
            o.Organization_Id == this.Organization.Organization_Id ||
            o.Parent_Organization_Id == this.Organization.Organization_Id
        );
        var orgIds = this.organizations.map(o => o.Organization_Id);
        this.subjects = (await this.$getPermissionSubjects()).filter(s =>
          orgIds.includes(s.Organization_Id.toString())
        );
        this.users = await this.$queryUsers(null, [
          this.Organization.Account.Account_Id
        ]);
      } else {
        this.$showSnackbar(
          "It looks like you do not have permission to manage users.",
          true
        );
      }
    },
    manageUser(user) {
      this.selectedUser = user;
      //this.originalUserStudentPermissions = [];
      this.newUserStudentPermissions = [];
      //this.originalUserSubjectPermissions = [];
      this.newUserSubjectPermissions = [];
      this.newUserOrganizationPermissions = [];
      user.Permissions.forEach(permission => {
        if (permission.Student_Id != null) {
          //this.originalUserStudentPermissions.push({student: permission.Student_Id, permission: permission.Permission_Id})
          this.newUserStudentPermissions.push({
            student: permission.Student_Id,
            permission: permission.Permission_Id
          });
        }
        if (permission.Subject_Id != null) {
          //this.originalUserSubjectPermissions.push({subject: permission.Subject_Id, permission: permission.Permission_Id})
          this.newUserSubjectPermissions.push({
            subject: permission.Subject_Id,
            permission: permission.Permission_Id
          });
        }
        if (permission.Organization_Id != null) {
          this.newUserOrganizationPermissions.push({
            organization: permission.Organization_Id,
            permission: permission.Permission_Id
          });
        }
      });
    },
    async addRemovePermission(event, permission) {
      this.$store.commit("updateLoading", true);
      if (permission.subject) {
        await this.addRemoveSubjectPermission(event.target.checked, permission);
      }
      if (permission.student) {
        await this.addRemoveStudentPermission(event.target.checked, permission);
      }
      if (permission.organization) {
        await this.addRemoveOrganizationPermission(
          event.target.checked,
          permission
        );
      }
    },
    async addRemoveSubjectPermission(checked, permission) {
      if (checked) {
        var newUserPermission = await this.$createSingleUserSubjectPermission(
          this.selectedUser.User_Id,
          permission.subject,
          permission.permission
        );
        this.selectedUser.Permissions.push({
          User_Permission_Id: newUserPermission.User_Permission_Id,
          Subject_Id: permission.subject,
          Permission_Id: permission.permission
        });
        if (this.selectedUser.User_Id == this.$store.getters.user.User_Id) {
          this.$store.getters.user.Permissions.push({
            User_Permission_Id: newUserPermission.User_Permission_Id,
            Subject_Id: permission.subject,
            Permission_Id: permission.permission
          });
        }
        this.$store.commit("updateLoading", false);
      } else {
        var userPermissionToRemoveIndex = this.selectedUser.Permissions.findIndex(
          p =>
            p.Subject_Id == permission.subject &&
            p.Permission_Id == permission.permission
        );
        await this.$removeUserPermissions([
          this.selectedUser.Permissions[userPermissionToRemoveIndex]
            .User_Permission_Id
        ]);
        this.selectedUser.Permissions.splice(userPermissionToRemoveIndex, 1);
        if (this.selectedUser.User_Id == this.$store.getters.user.User_Id) {
          var myPermissionToRemoveIndex = this.$store.getters.user.Permissions.findIndex(
            p =>
              p.Subject_Id == permission.subject &&
              p.Permission_Id == permission.permission
          );
          this.$store.getters.user.Permissions.splice(
            myPermissionToRemoveIndex,
            1
          );
        }
        this.$store.commit("updateLoading", false);
      }
    },
    async addRemoveStudentPermission(checked, permission) {
      if (checked) {
        var newUserPermission = await this.$createSingleUserStudentPermission(
          this.selectedUser.User_Id,
          permission.student,
          permission.permission
        );
        this.selectedUser.Permissions.push({
          User_Permission_Id: newUserPermission.User_Permission_Id,
          Student_Id: permission.student,
          Permission_Id: permission.permission
        });
        if (this.selectedUser.User_Id == this.$store.getters.user.User_Id) {
          this.$store.getters.user.Permissions.push({
            User_Permission_Id: newUserPermission.User_Permission_Id,
            Student_Id: permission.student,
            Permission_Id: permission.permission
          });
        }
        this.$store.commit("updateLoading", false);
      } else {
        var userPermissionToRemoveIndex = this.selectedUser.Permissions.findIndex(
          p =>
            p.Student_Id == permission.student &&
            p.Permission_Id == permission.permission
        );
        await this.$removeUserPermissions([
          this.selectedUser.Permissions[userPermissionToRemoveIndex]
            .User_Permission_Id
        ]);
        this.selectedUser.Permissions.splice(userPermissionToRemoveIndex, 1);
        if (this.selectedUser.User_Id == this.$store.getters.user.User_Id) {
          var myPermissionToRemoveIndex = this.$store.getters.user.Permissions.findIndex(
            p =>
              p.Student_Id == permission.student &&
              p.Permission_Id == permission.permission
          );
          this.$store.getters.user.Permissions.splice(
            myPermissionToRemoveIndex,
            1
          );
        }
        this.$store.commit("updateLoading", false);
      }
    },
    async addRemoveOrganizationPermission(checked, permission) {
      if (checked) {
        var newUserPermission = await this.$createSingleUserOrganizationPermission(
          this.selectedUser.User_Id,
          permission.organization,
          permission.permission
        );
        this.selectedUser.Permissions.push({
          User_Permission_Id: newUserPermission.User_Permission_Id,
          Organization_Id: permission.organization,
          Permission_Id: permission.permission
        });
        if (this.selectedUser.User_Id == this.$store.getters.user.User_Id) {
          this.$store.getters.user.Permissions.push({
            User_Permission_Id: newUserPermission.User_Permission_Id,
            Organization_Id: permission.organization,
            Permission_Id: permission.permission
          });
        }
        this.$store.commit("updateLoading", false);
      } else {
        var userPermissionToRemoveIndex = this.selectedUser.Permissions.findIndex(
          p =>
            p.Organization_Id == permission.organization &&
            p.Permission_Id == permission.permission
        );
        await this.$removeUserPermissions([
          this.selectedUser.Permissions[userPermissionToRemoveIndex]
            .User_Permission_Id
        ]);
        this.selectedUser.Permissions.splice(userPermissionToRemoveIndex, 1);
        if (this.selectedUser.User_Id == this.$store.getters.user.User_Id) {
          var myPermissionToRemoveIndex = this.$store.getters.user.Permissions.findIndex(
            p =>
              p.Organization_Id == permission.organization &&
              p.Permission_Id == permission.permission
          );
          this.$store.getters.user.Permissions.splice(
            myPermissionToRemoveIndex,
            1
          );
        }
        this.$store.commit("updateLoading", false);
      }
    },
    async savePermissions() {
      var view = this;
      view.$store.commit("updateLoading", true);
      var currentPermissions = view.getUserCurrentPermissions(view.editingUser);
      var addedPermissions = view.editingUserPermissions.filter(
        p =>
          !currentPermissions.some(c => {
            return (
              p.Permission == c.Permission && p.Organization == c.Organization
            );
          })
      );
      addedPermissions = addedPermissions.map(p => {
        var permission = {};
        permission.User_Id = parseInt(view.editingUser.User_Id);
        permission.Permission_Id = parseInt(p.Permission);
        permission.Organization_Id = parseInt(p.Organization);
        return permission;
      });
      var removedPermissions = view.editingUser.Permissions.filter(
        c =>
          !view.editingUserPermissions.some(p => {
            return (
              p.Permission == c.Permission.Permission_Id &&
              p.Organization == c.Organization.Organization_Id
            );
          })
      );
      try {
        await view
          .$addPermissions(addedPermissions, parseInt(view.editingUser.User_Id))
          .then(async () => {
            await view
              .$removePermissions(
                removedPermissions.map(p => parseInt(p.UserPermission_Id)),
                parseInt(view.editingUser.User_Id)
              )
              .then(permissions => {
                var orgIndex = view.organizations.findIndex(o =>
                  o.Users.some(u => u.User_Id == view.editingUser.User_Id)
                );
                var userIndex = view.organizations[orgIndex].Users.findIndex(
                  u => u.User_Id == view.editingUser
                );
                view.editingUser.Permissions = permissions;
                var organization = view.organizations[orgIndex];
                organization.Users[userIndex] = view.editingUser;
                view.$set(view.organizations, orgIndex, organization);
                this.$store.commit("updateLoading", false);
              });
          });
      } catch (err) {
        this.$store.commit("updateLoading", false);
      }
    },
    getUserCurrentPermissions(user) {
      return user.Permissions.map(p => {
        var permission = {};
        permission.Organization = p.Organization.Organization_Id;
        permission.Permission = p.Permission.Permission_Id;
        return permission;
      });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
p {
  margin-bottom: 0.2rem;
}
</style>
